module.exports = __webpack_public_path__ + "assets/EmptyShoppingCartStat-e29c07.svg";